export class KeyboardNavigator
{
    card = document.querySelector('[data-s~="KeyboardNavigator"]')
    buttons = document.querySelectorAll('[data-s~="KeyboardNavigator:show"]')

    constructor(store)
    {
        this.store = store
	}

    watch()
    {
        this.buttons.forEach(e => {
            e.addEventListener("click", () => {
                this.card.focus()
                this.store.service.Accessibility.check()
			})
		})
    }
}
